/*!
 * resource-template-url-getter v0.10.20 
 * (c) 2020 Alex Tkachenko
 * Released under the MIT License.
 */
import urlTemplate from 'url-template';

function makeTemplateGetter(template) {
  var compiled = urlTemplate.parse(template);
  return compiled.expand.bind(compiled);
}

export default makeTemplateGetter;



// WEBPACK FOOTER //
// ./node_modules/@aspectus/resource-template-url-getter/dist/resource-template-url-getter.esm.js